<template>
  <div class="card">
    <table class="table table-sm table-bordered table-striped">
      <thead class="bg-primary text-white text-center">
        <tr>
          <th width="20%">Código do Usuário do RM</th>
          <th width="20%">Perfil</th>
          <th width="50%">Centro de Custo Vinculado</th>
          <th width="10%">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="userProfile in usersProfiles"
          :key="userProfile.id"
          class="text-center"
        >
          <td>{{ userProfile.user }}</td>
          <td>{{ userProfile.profileName }}</td>
          <th>
            <span
              v-for="userProfileCodCCusto in userProfile.centroCustos"
              :key="userProfileCodCCusto.id"
              class="badge bg-success bg-opacity-20 text-success mb-2 ms-2"
            >
              {{ userProfileCodCCusto.codCCusto }}
              <span>
                <i
                  class="ph-trash text-danger cursor-pointer"
                  title="Remover Centro de Custo"
                  @click="
                    $emit('deleteUserProfileCodCCusto', {
                      userProfileId: userProfile.id,
                      userProfileCodCCustoId: userProfileCodCCusto.id,
                    })
                  "
                />
              </span>
            </span>
            <span
              v-if="userProfile.profileId == 1"
              class="badge bg-success bg-opacity-20 text-success ms-2"
            >
              <span>
                <i
                  class="ph-plus text-primary cursor-pointer"
                  title="Adicionar Centro de Custo"
                  @click="$emit('createUserProfileCodCCusto', userProfile.id)"
                />
              </span>
            </span>
          </th>
          <td class="p-1">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger btn-icon"
              title="Remover Permissão"
              @click="$emit('deleteUserProfile', userProfile.id)"
            >
              <i class="ph-trash" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'ListUsersProfiles',

  props: {
    usersProfiles: {
      type: Array,
      required: true,
    },
  },
}
</script>
